
















import { Component, Vue } from "vue-property-decorator";
import BaseComponent from "@/asdcom/BaseComponent";

@Component
export default class ErrorView extends BaseComponent {
}
